import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/jobFunctions/jobSiteOverviewActions'
import _ from 'lodash'
import { Spin } from 'antd'
import MaintenanceServiceOverview from '../../../components/jobs/overview/MaintenanceServiceOverview'
import DefaultOverview from '../../../components/jobs/overview/DefaultOverview'

const propTypes = {}

class JobSiteOverview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      jobSiteNote: ''
    }

    this.props.jobSiteOverviewsRefresh({
      jobId: this.props.jobId
    })
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.jobSiteOverviewActions.jobSiteOverviews !==
      prevProps.jobSiteOverviewActions.jobSiteOverviews
    ) {
      this.setState({
        jobSiteNote: this.props.jobSiteOverviewActions.jobSiteOverviews.data.job_site_note
      })
    }
  }

  handleJobSiteNoteChange = event => {
    this.setState({ jobSiteNote: event.target.value })
  }

  handleJobSiteNoteBlur = event => {
    this.props.updateJobSiteNote({
      jobId: this.props.jobId,
      userId: this.props.user.userId,
      note: this.state.jobSiteNote
    })
  }

  renderOverview = overviewTotals => {
    if (overviewTotals.jobType === 'Maintenance/Service') {
      return (
        <MaintenanceServiceOverview
          navToSection={this.props.navToSection}
          overviewTotals={overviewTotals.totals}
        />
      )
    } else {
      return (
        <DefaultOverview
          navToSection={this.props.navToSection}
          overviewTotals={overviewTotals.totals}
        />
      )
    }
  }

  render() {
    const overviewTotals = _.get(this.props, 'jobSiteOverviewActions.jobSiteOverviews.data')

    return (
      <Spin spinning={!overviewTotals ? true : false}>
        {overviewTotals && this.renderOverview(overviewTotals)}
      </Spin>
    )
  }
}

const mapStateToProps = ({ jobSiteOverviewActions }, ownProps) => ({ jobSiteOverviewActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobSiteOverview.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobSiteOverview))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteOverview.js